module.exports = __webpack_public_path__ + "static/media/devconnector.a90a48b4.png";